module.exports = __webpack_public_path__ + "img/marketing-ico.43807392.png";